import { render } from "./removeTags.vue?vue&type=template&id=2ea44c65"
import script from "./removeTags.vue?vue&type=script&lang=js"
export * from "./removeTags.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__